import { createReducer, on } from '@ngrx/store';
import { ClearState } from './search.actions';

// State for this feature
export interface SearchState {
  dummy: any;
}

const initialState: SearchState = {
  dummy: '',
};

export const reducer = createReducer(
  initialState,

  // CLEAR STATE
  on(ClearState, () => ({ ...initialState })),
);
